@switch (context ? context.type : '') {
    @default {
        <fui-edit-date-input [control]="control" [disabled]="disabled" #input
                             [label]="label" [placeholder]="placeholder" [(ngModel)]="value"
                             (focussed$)="onFocussed($event)"></fui-edit-date-input>
    }
    @case (contextType.FILTER) {
        <fui-filter-date-input [disabled]="disabled" #input [(ngModel)]="value" (focussed$)="onFocussed($event)"
                               [label]="label" [placeholder]="placeholder"></fui-filter-date-input>
    }
    @case (contextType.INLINE) {
        <fui-inline-date-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                               [placeholder]="placeholder"
                               (focussed$)="onFocussed($event)"></fui-inline-date-input>
    }
    @case (contextType.PILL) {
        <fui-pill-date-input [control]="control" [disabled]="disabled" #input [(ngModel)]="value"
                             [label]="label" [placeholder]="placeholder"
                             (focussed$)="onFocussed($event)" (removed$)="remove()"
        ></fui-pill-date-input>
    }
}
